import { computed, makeObservable } from 'mobx'
import moment from 'moment'
import type { $Values } from 'utility-types'

import { dateToString, stringToDate } from 'modules/core/lib/dates'
import { Model } from 'modules/core/lib/mobx-rest'

export const EventTypes = {
  SettingUpdated: 'setting_updated',
  BreakSettingUpdated: 'break_setting_updated',
  ToleranceSettingUpdated: 'tolerance_setting_updated',
  BalanceCarryoverUpdated: 'balance_carryover_updated',
}

export type Scalar = boolean | number | string | bigint | null | undefined

export const BOOLEAN_FIELDS = [
  'automatic_breaks',
  'desktop_clockin',
  'id_clock_shared_device',
  'enable_breaks',
  'geolocation',
  'manual_breaks',
  'mobile_clockin',
  'overtime_authorization',
  'qr_code_clockin',
]

export const SECOND_FIELDS = [
  'clock_in_after',
  'clock_in_before',
  'clock_out_after',
  'clock_out_before',
]

export const DATE_FIELDS = ['effective_at']

export const SPECIAL_FIELDS = ['accuracy']

export const POLICY_FIELDS = ['name', 'description']

interface IAttendanceSettingsEvent {
  full_name: string
  access_id: number
  employees_setting_id: number
  event_type: $Values<typeof EventTypes>
  timestamp: string
  changes?: {
    [key: string]: Scalar[]
  }
}
class AttendanceSettingsEvent extends Model<IAttendanceSettingsEvent> {
  constructor(attr: IAttendanceSettingsEvent) {
    super(attr)

    makeObservable(this, {
      timestamp: computed,
      timestampUI: computed,
    })
  }

  static urlRoot() {
    return '/api/rest/attendance/employees_settings_event'
  }

  get timestamp(): moment.Moment {
    const { timestamp } = this.attributes

    return timestamp ? stringToDate(timestamp, 'backend_datetime') : moment()
  }

  get timestampUI(): string {
    // We need this instead of convertDate(<date>, 'backend_datetime', 'ui_short_with_time') => 'DD/MM/YYYY HH:mm'
    // because we need to use the locale 'ui' => UI_DATE_FORMAT = 'L' => 'MM/DD/YYYY' or 'DD/MM/YYYY'
    // depending on the user's settings.
    const date = dateToString(this.timestamp, 'ui')
    const time = dateToString(this.timestamp, 'ui_time')

    return [date, time].join(' ')
  }
}

export default AttendanceSettingsEvent
